import React, { useEffect, useState } from 'react'
import useStore from '../../StorePeople/Store'
import ViewApiCall from '../../ViewApiCall'
import sliders from './images/slidersSVG.svg'
import Modal from './modal/ExpandedModal'
import styles from './styles.module.css'
// import codeIcon from "../SearchFilters/images/xmark.svg";
import codeIcon from '../../SearchFilters/images/xmark.svg'

const stylesFilters = {
  divStyles: {
    width: '1.5px',
    height: '23.5px',
    backgroundColor: '#ABABAB',
    margin: '0px 12.5px 2.5px 12.5px',
    display: 'block',
    alignSelf: 'end',
    paddingBottom: '5px'
  }
}

function ExpandedFilters () {
  const {
    fullName,
    title,
    city,
    state,
    isQueryLoading,
    streetAddress,
    postalCode,
    country,
    currentCompany,
    requiredFields,
    queryStore,
    recordRecency,
    resetStore,
    orFields,
    businessCategories,
    // R33: New property ownership filters
    mostRecentPropertyPurchaseDate,
    propertiesOwnedDatePurchased,
    propertiesOwnedDateSold
  } = useStore()

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [usedFiltersCount, setUsedFiltersCount] = useState(0)
  const dataType = 'people'
  const { name, lastName } = fullName

  useEffect(() => {
    const countUsedFilters = () => {
      let count = 0
      if (name) count++
      if (lastName) count++
      if (title) count++
      if (businessCategories) count++
      if (city.length > 0) count++
      if (state.length > 0) count++
      if (streetAddress) count++
      if (postalCode.length > 0) count++
      if (country) count++
      if (currentCompany) count++
      if (orFields?.length > 0) count++

      // Increment count if any value is present in recordRecency
      if (recordRecency?.dateAdded) count++
      if (recordRecency?.dateUpdated) count++

      // R33: Increment count for new property ownership filters
      if (mostRecentPropertyPurchaseDate?.startDate || mostRecentPropertyPurchaseDate?.endDate) count++
      if (propertiesOwnedDatePurchased?.startDate || propertiesOwnedDatePurchased?.endDate) count++
      if (propertiesOwnedDateSold?.includeNotSold || propertiesOwnedDateSold?.startDate || propertiesOwnedDateSold?.endDate) count++

      if (requiredFields.length > 0) count++
      setUsedFiltersCount(count)
    }

    countUsedFilters()
  }, [
    name,
    lastName,
    title,
    city,
    state,
    streetAddress,
    postalCode,
    country,
    currentCompany,
    requiredFields,
    recordRecency,
    orFields,
    businessCategories,
    // R33: New property ownership filters
    mostRecentPropertyPurchaseDate,
    propertiesOwnedDatePurchased,
    propertiesOwnedDateSold
  ])

  const toggleModal = () => {
    if (!isQueryLoading) {
      setIsModalVisible(!isModalVisible)
    }
  }

  const cursorStyle = isQueryLoading
    ? { opacity: '0.5', cursor: 'not-allowed' }
    : { cursor: 'pointer' }

  const handleClearFilters = () => {
    if (queryStore) {
      resetStore()
    }
  }

  const isDisabled = !queryStore || isQueryLoading

  return (
    <div className={styles.filterContainer}>
      <div
        onClick={isQueryLoading ? null : toggleModal}
        style={{ display: 'flex', paddingBottom: '5px', alignSelf: 'flex-end', cursor:"pointer" }}
      >
        <span
          onClick={isQueryLoading ? null : toggleModal}
          className={`${styles.filterLabel} ${styles.cursorStyle}`}
          style={cursorStyle}
        >
          All filters
        </span>

        <img
          src={sliders}
          alt='sliders'
          className={`${styles.filterIcon} ${styles.cursorStyle}`}
          style={cursorStyle}
          onClick={isQueryLoading ? null : toggleModal}
        />
        <span
          className={`${styles.filterLabel} ${styles.cursorStyle}`}
          style={cursorStyle}
          onClick={isQueryLoading ? null : toggleModal}
        >
          ({usedFiltersCount} Used)
        </span>
      </div>

      {isModalVisible && <Modal onClose={() => setIsModalVisible(false)} />}
      <div style={stylesFilters.divStyles}></div>

      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          paddingBottom: '5px'
        }}
      >
        <span
          onClick={queryStore === '' ? undefined : handleClearFilters}
          className={styles.clearFiltersSearch}
          style={{
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.5 : 1
          }}
        >
          Clear filters
        </span>
        <img
          onClick={queryStore === '' ? undefined : handleClearFilters}
          src={codeIcon}
          alt='codeIcon'
          style={{
            height: '14px',
            marginBottom: '1.5px',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.5 : 1
          }}
        />
      </div>

      <div style={stylesFilters.divStyles}></div>

      <ViewApiCall dataType={dataType} />
    </div>
  )
}

export default ExpandedFilters
